/**
 * 確定履歴の参照列プレビュー mutation hook (§5 確定履歴から取込 → 参照列プレビュー,
 * s07-confirm-history-import-reference-view.md)。
 *
 * PreviewConfirmRecord RPC を呼んで、選択した確定履歴 (48コマ値) を編集中の
 * 需要想定を上書きしない参照列として取得する。draft への書込みは行われない
 * (persist しない) — 応答は caller (useConfirmRecordImportFlow) が参照列 state
 * (confirmRecordRefIds 相当) へ追加するだけで、KomaGrid / ForecastChart の
 * 参照列/系列として表示される。楽観ロックは不要 (書込みが無いため
 * expected_updated_at を持たない)。
 */
import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { previewConfirmRecord } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import {
  PreviewConfirmRecordRequestSchema,
  PreviewConfirmRecordResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 確定履歴を参照列としてプレビュー取得する mutation hook (draft へ書込まない)。
 * request は caller が `create(PreviewConfirmRecordRequestSchema, {...})` で組み立てて渡す。
 */
export function usePreviewConfirmRecord(): UseMutationResult<
  MessageShape<typeof PreviewConfirmRecordResponseSchema>,
  ConnectError,
  MessageInitShape<typeof PreviewConfirmRecordRequestSchema>
> {
  return useMutation(previewConfirmRecord)
}
